import type { ReactNode, ThHTMLAttributes, TdHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

/**
 * טבלת נתונים לקונסולה. גלישה אופקית נשמרת בתוך המסגרת, כדי שטבלה
 * רחבה לא תמתח את כל הדף.
 */
export function Table({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className="w-full overflow-x-auto">
      <table className={cn('w-full border-collapse text-body-sm', className)}>{children}</table>
    </div>
  );
}

export function Th({ className, children, ...rest }: ThHTMLAttributes<HTMLTableCellElement>) {
  return (
    <th
      scope="col"
      className={cn(
        'border-b border-line bg-cream px-4 py-2.5 text-start text-label font-medium whitespace-nowrap text-muted',
        className,
      )}
      {...rest}
    >
      {children}
    </th>
  );
}

export function Td({ className, children, ...rest }: TdHTMLAttributes<HTMLTableCellElement>) {
  return (
    <td className={cn('border-b border-line px-4 py-3 align-middle text-ink', className)} {...rest}>
      {children}
    </td>
  );
}

/** שורה לחיצה. בדסקטופ ההדגשה בריחוף היא מה שמראה שאפשר ללחוץ. */
export function Tr({
  children,
  onClick,
  className,
}: {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
}) {
  return (
    <tr onClick={onClick} className={cn(onClick && 'cursor-pointer hover:bg-cream', className)}>
      {children}
    </tr>
  );
}
